// extracted by mini-css-extract-plugin
module.exports = {"nav-right-btn":"index-module_nav-right-btn_8ayMN","nav-back-btn":"index-module_nav-back-btn_M1hOr"};